import { Accelerator, isTpuAccelerator } from "../../types/Accelerator";
import { AppState } from "../types";
import { getAccelerator } from "./notebook";

export const getGpuQuotaStats = (state: AppState) =>
  state.acceleratorQuotaStats && state.acceleratorQuotaStats.gpu
    ? state.acceleratorQuotaStats.gpu
    : null;

export const getTpuQuotaStats = (state: AppState) =>
  state.acceleratorQuotaStats && state.acceleratorQuotaStats.tpu
    ? state.acceleratorQuotaStats.tpu
    : null;

export const getKernelsMaxSize = (state: AppState) =>
  state.acceleratorQuotaStats && state.acceleratorQuotaStats.kernelsMaxSizeInMb 
    && state.acceleratorQuotaStats.kernelsMaxSizeInMb >= 1
    ? state.acceleratorQuotaStats.kernelsMaxSizeInMb
    : 1;

export const getAcceleratorQuotaStats = (
  state: AppState,
  accelerator?: Accelerator
) => {
  if (!accelerator) {
    accelerator = getAccelerator(state);
  }
  if (accelerator === "gpu") {
    return getGpuQuotaStats(state);
  } else if (isTpuAccelerator(accelerator)) {
    return getTpuQuotaStats(state);
  }
  return null;
};

export const getIsAcceleratorQuotaExceeded = (state: AppState, accelerator?: Accelerator) => {
  const stats = getAcceleratorQuotaStats(state, accelerator);
  if (!stats) {
    return false;
  }
  return stats.secondsUsed >= stats.secondsAllowed;
};

export const getAcceleratorHoursRemaining = (state: AppState, accelerator?: Accelerator) => {
  const stats = getAcceleratorQuotaStats(state, accelerator);
  if (!stats) {
    return 100;
  }

  const secondsRemaining = stats.secondsAllowed - stats.secondsUsed;
  if (secondsRemaining < 0) {
    return 0;
  }

  return Math.round(secondsRemaining / 3600);
};

export const getAcceleratorQuotaLimitHours = (state: AppState, accelerator?: Accelerator) => {
  const stats = getAcceleratorQuotaStats(state, accelerator);
  if (!stats) {
    return null;
  }
  return Math.floor(stats.secondsAllowed / 3600);
};

export const getAcceleratorQuotaRefreshTime = (state: AppState) => {
  if (!state.acceleratorQuotaStats) {
    return Date.now();
  }

  return state.acceleratorQuotaStats.quotaRefreshTime;
};
